const Tooltip = ({ tooltipMessage }) => {
  return (
    <span className="absolute left-1/2 z-10 w-max -translate-x-1/2 whitespace-pre rounded bg-slate-800 dark:bg-slate-300 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg dark:text-slate-900">
      {tooltipMessage}
    </span>
  );
};

export default Tooltip;